import _ from 'lodash';

import { loading, handleErrorException } from 'State/actions';

import * as types from './types';

export const createSiteOrder = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.SCHOOL_SITE_ORDER_FETCHING, true));
    const res = await MPWWebApi.postGenericInsertUpdate(
      'MenuOrder/Write',
      data
    );
    const message = _.get(res, 'data.Data', 'Order has been placed.');
    dispatch(setSaveMessage(message));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.SCHOOL_SITE_ORDER_SET_ERROR, {
        Title: 'Error',
        Message: 'Failed to load create site order.',
      })
    );
  } finally {
    dispatch(loading(types.SCHOOL_SITE_ORDER_FETCHING, false));
  }
};

export const clearError = () => ({
  type: types.SCHOOL_SITE_ORDER_SET_ERROR,
  payload: null,
});

export const setSaveMessage = success => ({
  type: types.SCHOOL_SITE_ORDER_SET_SAVE_MESSAGE,
  payload: success,
});



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/state/actions.js